var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 35.7526H6.63639C6.43804 35.7526 6.23967 35.8181 6.10744 35.9493C5.71073 36.3426 5 37.3753 5 39.7684C5 41.8173 5.71073 42.768 6.10744 43.145C6.23967 43.2761 6.43807 43.3417 6.6199 43.3417H26.5",
    fill: "#343333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 35.7526H6.63639C6.43804 35.7526 6.23967 35.8181 6.10744 35.9493C5.71073 36.3426 5 37.3753 5 39.7684C5 41.8173 5.71073 42.768 6.10744 43.145C6.23967 43.2761 6.43807 43.3417 6.6199 43.3417H26.5",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.653 41.26C14.2563 41.6698 13.7274 41.8829 13.1488 41.8993H13.1323C11.9587 41.8993 11.0165 40.965 11 39.8012C11 39.2275 11.2149 38.703 11.6116 38.2932C12.0083 37.8834 12.5372 37.6703 13.1158 37.6539H13.1323C13.6943 37.6539 14.2232 37.867 14.6199 38.2604C15.0332 38.6538 15.2481 39.1783 15.2646 39.752C15.2811 40.3257 15.0497 40.8502 14.653 41.26Z",
    fill: "white",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6695 41.2108C19.2728 41.6206 18.7439 41.8337 18.1653 41.8501H18.1323C17.5703 41.8501 17.0414 41.637 16.6447 41.2436C16.2314 40.8502 16 40.3257 16 39.752C16 39.1783 16.2149 38.6538 16.6116 38.244C17.0083 37.8342 17.5372 37.6047 18.1158 37.6047H18.1323C18.6943 37.6047 19.2232 37.8178 19.6199 38.2112C20.0332 38.6046 20.248 39.1291 20.2646 39.7028C20.2646 40.2601 20.0497 40.801 19.653 41.2108H19.6695Z",
    fill: "white",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7357 39.1619C25.7357 47.5493 32.6076 54.3633 41.0419 54.3901V54.4066H41.0919C49.5656 54.4066 56.4481 47.5822 56.4481 39.1783C56.4481 30.7743 49.5491 23.95 41.0919 23.95C32.6348 23.95 25.7357 30.7579 25.7357 39.1619ZM26.6456 39.1783C26.6456 31.2729 33.1189 24.8532 41.0919 24.8532C49.0649 24.8532 55.5381 31.2729 55.5381 39.1783C55.5381 47.0837 49.0649 53.5034 41.0919 53.5034C33.1189 53.5034 26.6456 47.0837 26.6456 39.1783Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3401 28.9993H30.8437V49.3245H51.3401V28.9993Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0888 24.7953L26.5957 39.1673L41.0888 53.5394L55.582 39.1673L41.0888 24.7953Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5825 36H11.5825C11.5825 36.5 11.8825 37.5 13.0825 37.5C14.2825 37.5 14.5825 36.5 14.5825 36Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5825 43.5L14.5825 43.5C14.5825 43 14.2825 42 13.0825 42C11.8825 42 11.5825 43 11.5825 43.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65302 41.26C9.25632 41.6698 8.72737 41.8829 8.14885 41.8993H8.1323C6.95872 41.8993 6.01653 40.965 6 39.8012C6 39.2275 6.21492 38.703 6.61163 38.2932C7.00833 37.8834 7.53723 37.6703 8.11576 37.6539H8.1323C8.6943 37.6539 9.22323 37.867 9.61993 38.2604C10.0332 38.6538 10.2481 39.1783 10.2646 39.752C10.2811 40.3257 10.0497 40.8502 9.65302 41.26Z",
    fill: "white",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58252 36H6.58252C6.58252 36.5 6.88252 37.5 8.08252 37.5C9.28252 37.5 9.58252 36.5 9.58252 36Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58252 43.5L9.58252 43.5C9.58252 43 9.28252 42 8.08252 42C6.88252 42 6.58252 43 6.58252 43.5Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6939 36H16.6939C16.6939 36.5 16.9939 37.5 18.1939 37.5C19.3939 37.5 19.6939 36.5 19.6939 36Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6939 43.5L19.6939 43.5C19.6939 43 19.3939 42 18.1939 42C16.9939 42 16.6939 43 16.6939 43.5Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6695 41.1061C24.2728 41.5159 23.7439 41.7289 23.1653 41.7453H23.1323C22.5703 41.7453 22.0414 41.5322 21.6447 41.1389C21.2314 40.7455 21 40.2209 21 39.6473C21 39.0736 21.2149 38.549 21.6116 38.1393C22.0083 37.7295 22.5372 37.5 23.1158 37.5H23.1323C23.6943 37.5 24.2232 37.7131 24.6199 38.1065C25.0332 38.4999 25.248 39.0244 25.2646 39.5981C25.2646 40.1554 25.0497 40.6963 24.653 41.1061H24.6695Z",
    fill: "white",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6939 36H21.6939C21.6939 36.5 21.9939 37.5 23.1939 37.5C24.3939 37.5 24.6939 36.5 24.6939 36Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6939 43.2454L24.6939 43.2454C24.6939 42.7454 24.3939 41.7454 23.1939 41.7454C21.9939 41.7454 21.6939 42.7454 21.6939 43.2454Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 43.4564H75.1135C75.3118 43.4564 75.5102 43.3908 75.6424 43.2597C76.0391 42.8663 76.7499 41.8337 76.7499 39.4405C76.7499 37.3916 76.0391 36.4409 75.6424 36.0639C75.5102 35.9328 75.3118 35.8672 75.13 35.8672H55.5",
    fill: "#343333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 43.4564H75.1135C75.3118 43.4564 75.5102 43.3908 75.6424 43.2597C76.0391 42.8663 76.7499 41.8337 76.7499 39.4405C76.7499 37.3916 76.0391 36.4409 75.6424 36.0639C75.5102 35.9328 75.3118 35.8672 75.13 35.8672H55.5",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1695 41.1061C64.7728 41.5159 64.2439 41.7289 63.6653 41.7453H63.6323C63.0703 41.7453 62.5414 41.5322 62.1447 41.1389C61.7314 40.7455 61.5 40.2209 61.5 39.6473C61.5 39.0736 61.7149 38.549 62.1116 38.1393C62.5083 37.7295 63.0372 37.5 63.6158 37.5H63.6323C64.1943 37.5 64.7232 37.7131 65.1199 38.1065C65.5332 38.4999 65.748 39.0244 65.7646 39.5981C65.7646 40.1554 65.5497 40.6963 65.153 41.1061H65.1695Z",
    fill: "white",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0825 36H62.0825C62.0825 36.5 62.3825 37.5 63.5825 37.5C64.7825 37.5 65.0825 36.5 65.0825 36Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1695 41.1061C69.7728 41.5159 69.2439 41.7289 68.6653 41.7453H68.6323C68.0703 41.7453 67.5414 41.5322 67.1447 41.1389C66.7314 40.7455 66.5 40.2209 66.5 39.6473C66.5 39.0736 66.7149 38.549 67.1116 38.1393C67.5083 37.7295 68.0372 37.5 68.6158 37.5H68.6323C69.1943 37.5 69.7232 37.7131 70.1199 38.1065C70.5332 38.4999 70.748 39.0244 70.7646 39.5981C70.7646 40.1554 70.5497 40.6963 70.153 41.1061H70.1695Z",
    fill: "white",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0825 43.5L65.0825 43.5C65.0825 43 64.7825 42 63.5825 42C62.3825 42 62.0825 43 62.0825 43.5Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.153 41.26C59.7563 41.6698 59.2274 41.8829 58.6488 41.8993H58.6323C57.4587 41.8993 56.5165 40.965 56.5 39.8012C56.5 39.2275 56.7149 38.703 57.1116 38.2932C57.5083 37.8834 58.0372 37.6703 58.6158 37.6539H58.6323C59.1943 37.6539 59.7232 37.867 60.1199 38.2604C60.5332 38.6538 60.7481 39.1783 60.7646 39.752C60.7811 40.3257 60.5497 40.8502 60.153 41.26Z",
    fill: "white",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0825 36H57.0825C57.0825 36.5 57.3825 37.5 58.5825 37.5C59.7825 37.5 60.0825 36.5 60.0825 36Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0825 43.5L60.0825 43.5C60.0825 43 59.7825 42 58.5825 42C57.3825 42 57.0825 43 57.0825 43.5Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1939 36H67.1939C67.1939 36.5 67.4939 37.5 68.6939 37.5C69.8939 37.5 70.1939 36.5 70.1939 36Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1939 43.5L70.1939 43.5C70.1939 43 69.8939 42 68.6939 42C67.4939 42 67.1939 43 67.1939 43.5Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1695 41.1061C74.7728 41.5159 74.2439 41.7289 73.6653 41.7453H73.6323C73.0703 41.7453 72.5414 41.5322 72.1447 41.1389C71.7314 40.7455 71.5 40.2209 71.5 39.6473C71.5 39.0736 71.7149 38.549 72.1116 38.1393C72.5083 37.7295 73.0372 37.5 73.6158 37.5H73.6323C74.1943 37.5 74.7232 37.7131 75.1199 38.1065C75.5332 38.4999 75.748 39.0244 75.7646 39.5981C75.7646 40.1554 75.5497 40.6963 75.153 41.1061H75.1695Z",
    fill: "white",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1939 36H72.1939C72.1939 36.5 72.4939 37.5 73.6939 37.5C74.8939 37.5 75.1939 36.5 75.1939 36Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1939 43.2454L75.1939 43.2454C75.1939 42.7454 74.8939 41.7454 73.6939 41.7454C72.4939 41.7454 72.1939 42.7454 72.1939 43.2454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPave);
export default __webpack_public_path__ + "static/media/Pave.e6a8969456075a3f5200116d4e5b844b.svg";
export { ForwardRef as ReactComponent };